import React, { useEffect, useState } from 'react';
import Footer from './common/home/Footer';
import TopBar from './common/home/TopBar';
import {
  Box,
  LinearProgress,
  Typography
} from '@mui/material';
import { homeBackground } from './common/ColorCodes';
import './common/Styles.css'
import { useNavigate } from 'react-router-dom';
import { CONST_ROUTE_PATH } from '../route/RouteConstants';
import {
  CONST_SITE_LABEL,
  PAYMENT_STATUS_CODE,
  STORAGE_KEYS,
} from './common/Helper';
import DebugService from '../services/DebugService';
import { useAuth } from '../state/AuthContext';
import { useScopedLocalStorage } from '../hooks/useScopedLocalStorage';

/**
 * Response Handler Component
 * @returns 
 */
export const ResponseHandler = () => {
  const [isLoading, setIsLoading] = useState(true)

  const navigate = useNavigate()
  // const { details } = useParams()
  const { userDetails, loadingUserDetails } = useAuth()
  const { getScopedItem } = useScopedLocalStorage()

  // const checkForUserSubscription = (userId) => {
  //   const userSubscriptionIntervalId = setInterval(async () => {
  //     await SubscriptionApiService.getPurchasedPlanList({ userId })
  //       .then(async (res) => {
  //         const userSubscriptionData = res['data'] ?? []
  //         if (userSubscriptionData.length > 0) {
  //           const { latestRecord } = customArrayOperations(userSubscriptionData, 'createdOn')

  //           // Handle latest subscription status
  //           if (latestRecord !== undefined || latestRecord !== null) {
  //             if ([SUBSCRIPTION_STATUS.AUTHENTICATED, SUBSCRIPTION_STATUS.ACTIVE].includes(latestRecord['status'])) {
  //               clearInterval(userSubscriptionIntervalId)
  //               await refetchUserDetails()
  //               navigate(CONST_ROUTE_PATH.THANK_YOU)
  //             }
  //           }
  //         }
  //       })
  //   }, 30000)
  // }

  // const checkUserLogin = () => {
  //   if (loadingUserDetails === null || !userDetails['userId']) {
  //     DebugService.log(`Response Handler Component: User details not found`)
  //     navigate(CONST_ROUTE_PATH.PRICING)
  //   }
  // }

  useEffect(() => {
    if (loadingUserDetails === false && userDetails['userId']) {
      DebugService.log(`Response Handler Component: Payment details`, window.location)

      if (window.location.search.includes('success') || window.location.search.includes(true)) {
        navigate(CONST_ROUTE_PATH.THANK_YOU)
      } else {
        navigate(`${CONST_ROUTE_PATH.PAYMENT_FAILED}/${PAYMENT_STATUS_CODE.PSC001}`)
      }

    } else {
      const storedUserDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
      const parseToJsonUserDetails = JSON.parse(storedUserDetails)
      if (parseToJsonUserDetails['userId']) {
        if (window.location.search.includes('success') || window.location.search.includes(true)) {
          navigate(CONST_ROUTE_PATH.THANK_YOU)
        } else {
          navigate(`${CONST_ROUTE_PATH.PAYMENT_FAILED}/${PAYMENT_STATUS_CODE.PSC001}`)
        }

      } else {
        // checkUserLogin()
        DebugService.log(`Response Handler Component: User details not found`)
        navigate(CONST_ROUTE_PATH.PRICING)
      }
    }
  }, [])

  useEffect(() => {
    document.title = `${CONST_SITE_LABEL} | Payment`

    // checkUserLogin()

    // const paymentDetails = JSON.parse(atob(details) ?? '') ?? {}
    // DebugService.log(`Response Handler Component: Payment details`, window.location)

    // if (Object.keys(paymentDetails).length > 0) {
    //   if (paymentDetails['paymentDetails'] && paymentDetails['paymentDetails']['razorpay_payment_id']) {

    //     const requestBody = {
    //       userId: paymentDetails['userId'],
    //       razorpaySubscriptionId: paymentDetails['subscriptionId'],
    //       accountId: paymentDetails['accountId'],
    //       razorpayResponse: paymentDetails['paymentDetails']
    //     }

    //     SubscriptionApiService.verifySubscription(requestBody)
    //       .then(res => {
    //         const data = res['data'] ?? {}
    //         DebugService.log(`Response Handler Component: Purchased plan response`, paymentDetails, requestBody, data)

    //         if (data.length > 0) {
    //           checkForUserSubscription(paymentDetails['userId'])
    //         } else {
    //           DebugService.error(`Response Handler Component: Data not received for subscription verification`, paymentDetails, requestBody, res)
    //         }
    //       })
    //       .catch(err => {
    //         DebugService.error(`Response Handler Component: Error caught while verifying subscription`, paymentDetails, requestBody, err)
    //         navigate(`${CONST_ROUTE_PATH.PAYMENT_FAILED}/${PAYMENT_STATUS_CODE.PSC001}`)
    //       })
    //       .finally(() => {
    //         // Remove page redirect
    //         if (sessionStorage.getItem(STORAGE_KEYS.REDIRECT_URL)) {
    //           sessionStorage.removeItem(STORAGE_KEYS.REDIRECT_URL)
    //         }
    //       })
    //   } else {
    //     DebugService.error(`Response Handler Component: Razorpay Payment Id not received`, paymentDetails)
    //     navigate(`${CONST_ROUTE_PATH.PAYMENT_FAILED}/${PAYMENT_STATUS_CODE.PSC002}`)
    //   }
    // } else {
    //   DebugService.error(`Response Handler Component: Payment details not received`, paymentDetails)
    //   navigate(`${CONST_ROUTE_PATH.PAYMENT_FAILED}/${PAYMENT_STATUS_CODE.PSC003}`)
    // }
  }, [])

  return (
    <div style={{ backgroundColor: homeBackground }}>
      <TopBar />

      {isLoading && (
        <Box style={{
          width: '70vw',
          margin: '10vw'
        }}>
          <Typography component='p'>Payment in progress. Please do not refresh or close the browser...</Typography>
          <LinearProgress />
        </Box>
      )}


      <Footer />
    </div>
  )
}
